import React, { useState } from 'react';
import { ButtonCallToAction, ButtonTertiary, PromptConfirmation } from 'ui';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { LinkCodesTranslation } from '../constants';
import { useListActionsCallbacks } from '../hooks';
import { ListHeaderActions } from './list-header-actions';
import { ListHeaderVisibility } from './list-header-visibility';

import styles from './list-header.scss';
import { ListHeaderSwitch } from 'app/area/link-codes/components/list-header-switch';

interface ListHeaderProps {
  hasChanges: boolean;
  displayInfoText: boolean;
  displayNumberOfResults: boolean;
  numberOfResults: number;
  includeInactive: boolean;
  translation: LinkCodesTranslation;
}

export const ListHeader: React.FC<ListHeaderProps> = ({
  hasChanges, displayInfoText, includeInactive,
  displayNumberOfResults, numberOfResults, translation
}) => {

  const [shouldPrompt, setShouldPrompt] = useState(false);

  const showPrompt = () => {
    setShouldPrompt(true);
  };

  const hidePrompt = () => {
    setShouldPrompt(false);
  };

  const { saveChanges, cancelChanges } = useListActionsCallbacks();

  const onSave = () => {
    saveChanges(translation.message_codes_updated, translation.validation_error);
  };

  return <>
    {shouldPrompt && <PromptConfirmation
      title={translation.cancel_changes}
      description={translation.are_you_sure}
      continueText={translation.undo_all}
      cancelText={translation.go_back}
      onContinue={cancelChanges}
      onCancel={hidePrompt} />}
    <StickyHeader
      className={styles.header}
      rightSideContent={<StickyHeaderButtonContainer>
        <div className={styles.buttonContainer}>
          <ButtonTertiary
            id="link_codes_cancel_changes"
            onClick={showPrompt}
            disabled={!hasChanges}>
            {translation.cancel_changes}
          </ButtonTertiary>
          <ButtonCallToAction
            id="texts_save_changes"
            onClick={onSave}
            disabled={!hasChanges}>
            {translation.update_codes}
          </ButtonCallToAction>
        </div>
      </StickyHeaderButtonContainer>}>
      <div className={styles.dropdownContainer}>
        <ListHeaderActions translation={translation} />
        <ListHeaderVisibility translation={translation} />
      </div>
    </StickyHeader>

    {displayInfoText ? <div className={styles.alertInfoContainer}>
      <div className={`${styles.alertInfo} mb-2`}>
        <p>{translation.message_toggle_off_info}</p>
      </div>
    </div> : null}

    <div className={styles.searchSummary}>
      <div id="link_codes_number_of_results" className={styles.numberOfResults}>
        {displayNumberOfResults && numberOfResults
          ? `${numberOfResults} ${translation.search_hits}`
          : null}
      </div>
      <ListHeaderSwitch
        className={styles.switch}
        hasChanges={hasChanges}
        includeInactive={includeInactive}
        translation={translation} />
    </div>
  </>;
};
